export const STATIC_PAGE_COPY_ID = {
  "/": {
    "title": "Heartopia.guide — Peta Pulau, Resep & Pelacak Koleksi",
    "description":
      "Panduan lapangan Heartopia buatan pemain: peta pulau interaktif, ikan, serangga, burung, tanaman, resep memasak, NPC, kode hadiah, dan pelacak koleksi lengkap.",
  },
  "/map": {
    "title": "Peta Pulau Heartopia Interaktif — Semua Lokasi | Heartopia.guide",
    "description":
      "Jelajahi peta pulau Heartopia selengkapnya: setiap lokasi, area memancing, NPC, dan toko, dengan filter untuk tempat ikan, area mencari makan, dan barang koleksi.",
  },
  "/tracker": {
    "title": "Pelacak Koleksi Heartopia — Ikan, Serangga, Burung & Lainnya | Heartopia.guide",
    "description":
      "Lacak koleksi Heartopia: tandai ikan, serangga, burung, tanaman, bunga, hasil alam, resep, dan hewan yang sudah dikoleksi. Progres tersimpan di browser Anda.",
  },
  "/items": {
    "title": "Semua Item Heartopia — Katalog Lengkap | Heartopia.guide",
    "description":
      "Jelajahi katalog item Heartopia lengkap: ikan, serangga, burung, tanaman, bunga, hidangan, peralatan, furnitur, dan lainnya, lengkap dengan harga jual dan sumbernya.",
  },
  "/locations": {
    "title": "Semua Lokasi Heartopia | Heartopia.guide",
    "description":
      "Setiap lokasi di Heartopia: apa yang dapat Anda pancing, tangkap, dan cari makan di setiap area, ditambah NPC dan toko-toko yang akan Anda temukan di sana.",
  },
  "/npcs": {
    "title": "NPC Heartopia — Peran, Toko & Jadwal | Heartopia.guide",
    "description":
      "Temui setiap Heartopia NPC: peran mereka di pulau, toko mana yang mereka jalankan, dan di mana menemukannya sehari-hari.",
  },
  "/shops": {
    "title": "Semua Toko Heartopia & Apa yang Mereka Jual | Heartopia.guide",
    "description":
      "Setiap toko di Heartopia dengan stok lengkapnya: apa yang dijual setiap toko, harga, dan NPC mana yang menjalankannya.",
  },
  "/wardrobe": {
    "title": "Semua Pakaian & Aksesori di Heartopia | Heartopia.guide",
    "description":
      "Semua 2.239 item pakaian di Heartopia — topi, atasan, bawahan, sepatu, tas dan rambut — bisa disaring per jenis, koleksi dan warna, lengkap dengan harga dan semua varian desain.",
  },
  "/buildings": {
    "title": "Semua Bagian Bangunan di Heartopia — Mode Bangun | Heartopia.guide",
    "description":
      "Semua 452 bagian mode bangun di Heartopia — pintu, jendela, atap, pagar, ukiran dinding dan tekstur dinding maupun lantai — dikelompokkan per gaya bangunan, lengkap dengan harga.",
  },
  "/guides": {
    "title": "Panduan Heartopia — Fishing, Cooking, Hewan Peliharaan & Leveling | Heartopia.guide",
    "description":
      "Panduan Heartopia pemula dan lanjutan: memancing, berkebun, memasak, mengamati burung, menangkap serangga, merawat hewan peliharaan, dan strategi leveling cepat.",
  },
  "/achievements": {
    "title": "Daftar Pencapaian Heartopia | Heartopia.guide",
    "description":
      "Semua pencapaian Heartopia dan cara menyelesaikannya — persyaratan, hadiah, dan tips untuk melengkapi catatan pencapaianmu.",
  },
  "/weather": {
    "title": "Panduan Cuaca Heartopia — Kondisi dan Kemunculan | Heartopia.guide",
    "description":
      "Pelajari cuaca di Heartopia: ikan, serangga, dan event yang bergantung pada hujan, salju, atau kondisi lain, serta cara merencanakan aktivitas berdasarkan prakiraan.",
  },
  "/events": {
    "title": "Kalender Event Heartopia — Event Aktif & Sebelumnya | Heartopia.guide",
    "description":
      "Semua event Heartopia: event musiman aktif dan sebelumnya, item eksklusif, serta cara mendapatkan hadiah sebelum event berakhir.",
  },
  "/pets": {
    "title": "Hewan Peliharaan Heartopia — Anjing, Kucing, Sifat & Perawatan | Heartopia.guide",
    "description":
      "Segala sesuatu tentang hewan peliharaan Heartopia: semua ras anjing dan kucing, ciri-ciri hewan peliharaan, dan cara mengadopsi, memberi makan, dan merawat teman Anda.",
  },
  "/pets/dogs": {
    "title": "Semua Ras Anjing di Heartopia | Heartopia.guide",
    "description":
      "Setiap ras anjing yang dapat Anda adopsi di Heartopia, dengan penampilan, sifat, dan detail adopsi untuk masing-masing ras.",
  },
  "/pets/cats": {
    "title": "Semua Ras Kucing di Heartopia | Heartopia.guide",
    "description":
      "Setiap ras kucing yang dapat Anda adopsi di Heartopia, dengan detail penampilan, sifat, dan adopsi untuk masing-masing ras.",
  },
  "/pets/traits": {
    "title": "Penjelasan Sifat Hewan Peliharaan Heartopia | Heartopia.guide",
    "description":
      "Semua ciri kepribadian hewan peliharaan di Heartopia dan fungsinya — bagaimana sifat memengaruhi perilaku hewan peliharaan Anda dan kombinasi mana yang harus dicari.",
  },
  "/pets/guide": {
    "title": "Panduan Perawatan Hewan Peliharaan Heartopia | Heartopia.guide",
    "description":
      "Cara merawat hewan peliharaan di Heartopia: adopsi, pemberian makan, kebahagiaan, jalan-jalan, dan segala hal lain yang dibutuhkan anjing atau kucing Anda sehari-hari.",
  },
  "/daily-checklist": {
    "title": "Checklist Harian Heartopia — Jangan Lewatkan Tugas | Heartopia.guide",
    "description":
      "Daftar periksa harian untuk Heartopia: tugas berulang, pengaturan ulang, dan rutinitas untuk memaksimalkan setiap hari dalam game.",
  },
  "/codes": {
    "title": "Kode Redeem Heartopia — Kode Aktif & Hadiah | Heartopia.guide",
    "description":
      "Semua kode hadiah Heartopia yang aktif dan hadiahnya, ditambah cara menukarkannya — diperiksa dan diperbarui secara berkala.",
  },
  "/tracking-winter-season": {
    "title": "Pelacak Musim Dingin Heartopia | Heartopia.guide",
    "description":
      "Lacak musim dingin Heartopia: ikan musiman, serangga, item acara, dan segala sesuatu yang hanya dapat Anda kumpulkan selama musim dingin berlangsung.",
  },
  "/support": {
    "title": "Dukung Heartopia.guide | Heartopia.guide",
    "description":
      "Cara untuk mendukung Heartopia.guide — panduan lapangan gratis buatan pemain — dan membantu terus memperbaruinya untuk semua orang.",
  },
  "/news": {
    "title": "Berita Heartopia — Update, Event & Liputan Patch | Heartopia.guide",
    "description":
      "Berita Heartopia terbaru: pembaruan game, event musiman, konten baru, dan catatan patch dalam satu tempat.",
  },
  "/sitemap": {
    "title": "Peta Situs — Semua Halaman di Heartopia.guide | Heartopia.guide",
    "description":
      "Jelajahi setiap bagian Heartopia.guide dalam satu tempat: ikan, serangga, burung, bunga, resep, NPC, lokasi, panduan, dan berita.",
  },
} as const;
